<script lang="ts">
  import { onMount } from "svelte";
  import BlockPostCard from "$lib/molecules/newsroom/cards/BlockPostCard.svelte";
  export let posts: any;
</script>

<div class="grid sm:grid-cols-2 md:grid-cols-3 gap-[25px] gap-y-[30px]">
  {#if posts}
    {#each posts as post}
      <BlockPostCard {post} />
    {/each}
  {/if}
</div>
